<section>
  <h2> Data protection declaration</h2>
  <h3> Contact details of the controller </h3>

  The controller within the meaning of the General Data Protection Regulation and other national data protection laws
  of the EU member states as well as other data protection regulations is:
  <a href="https://www.cosy.bio/contact">Cosy.bio</a>
  <h3> A. Data processing</h3>

  1. Provision of the website and creation of log files
  Data and information are collected each time this website is accessed and used. These data and information are stored
  in the server's log files. The following can be collected:
  <ul>
    <li>
      IP address
    </li>
    <li>
      Information about the browser type and version used
    </li>
    <li>
      Date and time of access
    </li>
    <li>
      User's operating system
    </li>
  </ul>

  The legal basis for the temporary storage of data and log files is Art. 6 (1e) GDPR in conjunction with Section 4 of
  the German Data Protection Act (HmDSG) in conjunction with Sections 3 and 4 of the German Federal Data Protection Act
  (HmbHG).
  The system needs to store the IP address temporarily to enable the website to be delivered to the user's computer. To
  do this, the user's IP address must be stored for the duration of the session.
  Storage in log files is done to ensure the functionality of the website, to optimize the content of the website and to
  ensure the security of our information technology systems.
  The data will be deleted as soon as it is no longer required for the purpose for which it was collected. In the case
  of data collection for the provision of the website, this is the case when the respective session has ended.
  If the data is stored in log files, this is the case after 28 days at the latest. It is possible to store the data for
  a longer period of time. In this case, the IP addresses of the users are deleted or anonymized so that it is no longer
  possible to assign them to the accessing client.

  <h3> B. Cookies</h3>
  Our website does not use any third-party cookies.
  D. Transfer of data to third parties
  All documents or information that you enter will be processed by us in order to provide the service. If you have not
  prevented this in the settings. If you have selected an external service, the data will be passed on accordingly.
  <h3> C. Rights of the data subject</h3>
  You have the following rights:
  Right of access to the data we have stored about you (Art. 15 GDPR);
  Right to rectification of inaccurate personal data concerning you or to have incomplete personal data completed (Art.
  16 GDPR);
  Right to erasure of personal data concerning you, unless processing is necessary for exercising the right of freedom
  of expression and information, for compliance with a legal obligation, for reasons of public interest or for the
  establishment, exercise or defense of legal claims (Art. 17 GDPR);
  Right to restriction of processing of personal data (Art. 18 GDPR);
  Right to data portability (Art. 20 GDPR);
  Right to object to processing that serves our legitimate interest, a public interest or profiling, unless we can
  demonstrate compelling legitimate grounds for the processing that outweigh your interests, rights and freedoms, or the
  processing serves to assert, exercise or defend legal claims (Art. 21 GDPR);
  Right to revoke consent to collect, process and use your personal data at any time with effect for the future (Art. 7
  para. 3 GDPR). As a result, we are no longer allowed to continue the data processing based on this consent in the
  future.
  Right to lodge a complaint with a supervisory authority if you consider that the processing of personal data relating
  to you infringes the GDPR (Art. 77 GDPR).
  <h3> D. Revocation of consent/objection to processing</h3>
  The information provided with the respective declaration of consent will tell you to whom you can address your
  revocation of consent.
  <h3> E. Rights of data subjects</h3>
  You can assert your rights as a data subject, such as the right to information about stored data, against
  datenschutz[at]cosy.bio.
</section>
